module.exports = __webpack_public_path__ + "img/memory_4.046a9467.jpg";